// ✅ SISTEMA GLOBALE DI GESTIONE PODCAST
class PodcastManager {
  constructor() {
    this.activePodcasts = new Map(); // Mappa per tracciare podcast attivi
    this.currentPodcastId = null; // ID del podcast attualmente in riproduzione
    this.podcastCounter = 0; // Contatore per ID univoci
    
    // Log di inizializzazione
    console.log('🎧 PodcastManager initialized');
  }

  // Genera un ID univoco per ogni podcast
  generatePodcastId() {
    return `podcast_${++this.podcastCounter}_${Date.now()}`;
  }

  // Registra un nuovo podcast
  registerPodcast(url, title, modalElement = null) {
    const podcastId = this.generatePodcastId();
    
    const podcastInfo = {
      id: podcastId,
      url,
      title,
      modalElement,
      startTime: Date.now(),
      isActive: true
    };

    this.activePodcasts.set(podcastId, podcastInfo);
    console.log(`🎧 Registered podcast: ${title} (ID: ${podcastId})`);
    console.log(`🎧 Total active podcasts: ${this.activePodcasts.size}`);
    
    return podcastId;
  }

  // Ferma un podcast specifico
  stopPodcast(podcastId) {
    const podcast = this.activePodcasts.get(podcastId);
    if (!podcast) {
      console.log(`⚠️ Podcast not found: ${podcastId}`);
      return false;
    }

    console.log(`🔇 Stopping podcast: ${podcast.title} (ID: ${podcastId})`);

    // Trova e ferma l'iframe del podcast
    if (podcast.modalElement) {
      const iframe = podcast.modalElement.querySelector('iframe');
      if (iframe) {
        const originalSrc = iframe.src;
        iframe.src = 'about:blank';
        
        // Ricarica dopo un breve delay per fermare completamente l'audio
        setTimeout(() => {
          if (iframe.parentNode && podcast.isActive) {
            iframe.src = originalSrc;
          }
        }, 100);
      }
    }

    // Rimuovi dalla mappa
    this.activePodcasts.delete(podcastId);
    
    if (this.currentPodcastId === podcastId) {
      this.currentPodcastId = null;
    }

    console.log(`✅ Podcast stopped: ${podcast.title}`);
    console.log(`🎧 Remaining active podcasts: ${this.activePodcasts.size}`);
    
    return true;
  }

  // Ferma tutti i podcast tranne quello specificato
  stopAllExcept(exceptPodcastId = null) {
    console.log(`🔇 Stopping all podcasts${exceptPodcastId ? ` except ${exceptPodcastId}` : ''}`);
    
    const podcastsToStop = [];
    
    for (const [podcastId, podcast] of this.activePodcasts) {
      if (podcastId !== exceptPodcastId) {
        podcastsToStop.push(podcastId);
      }
    }

    let stoppedCount = 0;
    podcastsToStop.forEach(podcastId => {
      if (this.stopPodcast(podcastId)) {
        stoppedCount++;
      }
    });

    console.log(`✅ Stopped ${stoppedCount} podcasts`);
    return stoppedCount;
  }

  // Ferma tutti i podcast
  stopAllPodcasts() {
    return this.stopAllExcept(null);
  }

  // Pulisce tutti i podcast e resetta il manager
  resetAllPodcasts() {
    console.log('🔄 Resetting all podcasts...');
    
    // Ferma tutti i podcast attivi
    this.stopAllPodcasts();
    
    // Reset completo
    this.activePodcasts.clear();
    this.currentPodcastId = null;
    
    // Trova e chiude tutti i modal di podcast nel DOM
    this.cleanupDOMPodcasts();
    
    console.log('✅ All podcasts reset');
  }

  // Pulizia del DOM per podcast residui
  cleanupDOMPodcasts() {
    // Trova tutti i modal con attributo podcast
    const podcastModals = document.querySelectorAll('[data-resource-modal="podcast"]');
    podcastModals.forEach(modal => {
      const iframe = modal.querySelector('iframe');
      if (iframe) {
        iframe.src = 'about:blank';
      }
      // Nascondi il modal
      modal.style.display = 'none';
    });

    // Trova iframe di podcast con pattern URL specifici
    const allIframes = document.querySelectorAll('iframe');
    allIframes.forEach(iframe => {
      if (iframe.src && iframe.src.includes('disctopia.com/podcast')) {
        console.log(`🔇 Cleaning up iframe: ${iframe.src}`);
        iframe.src = 'about:blank';
      }
    });

    // Rimuovi modal di podcast orfani
    const fixedModals = document.querySelectorAll('.fixed.inset-0.z-50');
    fixedModals.forEach(modal => {
      const iframe = modal.querySelector('iframe[src*="disctopia.com/podcast"]');
      if (iframe) {
        console.log('🗑️ Removing orphaned podcast modal');
        setTimeout(() => {
          if (modal.parentNode) {
            modal.parentNode.removeChild(modal);
          }
        }, 500);
      }
    });
  }

  // Imposta il podcast corrente
  setCurrentPodcast(podcastId) {
    if (this.activePodcasts.has(podcastId)) {
      // Ferma tutti gli altri podcast
      this.stopAllExcept(podcastId);
      this.currentPodcastId = podcastId;
      
      const podcast = this.activePodcasts.get(podcastId);
      console.log(`🎵 Current podcast set: ${podcast.title}`);
    }
  }

  // Ottieni informazioni sui podcast attivi
  getActivePodcasts() {
    return Array.from(this.activePodcasts.values());
  }

  // Ottieni il podcast corrente
  getCurrentPodcast() {
    return this.currentPodcastId ? this.activePodcasts.get(this.currentPodcastId) : null;
  }

  // Debug: stampa stato attuale
  debugStatus() {
    console.log('🎧 PodcastManager Status:');
    console.log(`📊 Active podcasts: ${this.activePodcasts.size}`);
    console.log(`🎵 Current podcast: ${this.currentPodcastId || 'None'}`);
    
    if (this.activePodcasts.size > 0) {
      console.log('📋 Active podcast list:');
      for (const [id, podcast] of this.activePodcasts) {
        console.log(`  - ${id}: ${podcast.title}`);
      }
    }
  }
}

// Crea istanza globale singleton
const podcastManager = new PodcastManager();

// Esporta l'istanza singleton
export default podcastManager;

// Esporta anche la classe per testing se necessario
export { PodcastManager };